import React, { useEffect, useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { config } from "@fortawesome/fontawesome-svg-core"
import { faXmark, faBars } from "@fortawesome/free-solid-svg-icons"
import MenuLinks from "./menu-links"
import { AnchorLink } from "gatsby-plugin-anchor-links"
// disable the auto CSS insertion
config.autoAddCss = false

const Header = ({ siteTitle }) => {

  const [navbarOpen, setNavbarOpen] = useState(false)
  const [animateHeader, setAnimateHeader] = useState(false)

  useEffect(() => {
    const listener = () => {
      if (window.scrollY > 140) {
        setAnimateHeader(true)
      } else setAnimateHeader(false)
    }

    window.addEventListener("scroll", listener)

    return () => {
      window.removeEventListener("scroll", listener)
    }
  });

  const handleToggle = () => {
    setNavbarOpen(!navbarOpen)
  }

  const closeMenu = () => {
    setNavbarOpen(false)
  }

  const isBrowser = typeof window !== "undefined"

  const handleResize = () => {
    if (navbarOpen && window.innerWidth > 768) {
      setNavbarOpen(false)
    }
  }

  if (isBrowser) window.addEventListener("resize", handleResize)

  return (
    <>
      <header className={`${animateHeader ? "bg-header-sticky backdrop-filter backdrop-blur-[4px] transition-colors duration-500 bg-[#000000dd]" : "bg-transparent"} fixed pt-2 top-0 z-30 w-full text-white shadow-sm px-4 md:px-10`}>
        <div className={`${animateHeader ? "pt-1 pb-1" : "py-1"}  md:justify-end  max-w-theme-max-w my-0 mx-auto flex flex-wrap md:flex-nowrap`}>
          <div className="flex md:hidden items-center">
            <button id="mobile-menu-btn" className="h-fit text-sm leading-normal px-4 py-1 rounded text-white" onClick={handleToggle}>
              {navbarOpen ?
                <FontAwesomeIcon icon={faXmark} className={`w-5 hover:text-theme-yellow`} /> :
                <FontAwesomeIcon icon={faBars} className={`w-5 hover:text-theme-yellow`} />}
            </button>
          </div>

          <div className={`${animateHeader ? "opacity-1" : "opacity-0"} transition-opacity duration-300 flex-auto self-center`}>
            <AnchorLink to="#top" className="flex justify-center md:justify-start">
              <StaticImage
                src="../images/abed-group-logo.svg"
                loading="eager"
                width={92}
                formats={["auto", "webp", "avif"]}
                alt={siteTitle}
                className="inline-block"
              />
            </AnchorLink>
          </div>

          <ul id="header-links" className={`hidden h-[calc(100vh-7rem)] sm:h-full w-full md:w-auto flex-col md:flex md:flex-row md:mt-0 ${navbarOpen ? "open" : ""}`}>
            <MenuLinks
              onClickFn={closeMenu}
            />
          </ul>

          <div className="flex invisible md:hidden items-center">
            <button id="mobile-menu-btn" className="h-fit text-sm leading-normal px-4 py-1 rounded text-white" onClick={handleToggle}>
              {navbarOpen ?
                <FontAwesomeIcon icon={faXmark} className={`w-5 hover:text-theme-yellow`} /> :
                <FontAwesomeIcon icon={faBars} className={`w-5 hover:text-theme-yellow`} />}
            </button>
          </div>
        </div>

        <div className="max-w-theme-max-w my-0 md:mx-auto flex"></div>
      </header>
    </>
  )
}

export default Header